<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div class="col-12 mt-4">
		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<throbber />
			<p class="my-4">Veuillez patienter pendant la génération du sous-titrage...</p>
		</b-modal>

		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>

		<b-modal ref="sourceLangModal"
			hide-footer
			id="modal-source-languages"
			centered
			title="Dans quelle langue les personnes interviewées parlent dans ce projet ?"
			size="lg"
			:style="'color:' + this.primaryColor">
			<b-row>
				<div style="display: flex;">
					<b-col>
						<a href="#"
							v-for="(sourceLanguage, index) in this.sourceLanguages"
							:key="index"> <img class="card-img-top"
							:src="sourceLanguage.img"
							v-bind:class="{ selected: sourceLanguage.isSelected }"
							@click.prevent="getLanguagesId(index)"> </a>
					</b-col>
				</div>
			</b-row>
			<b-row>
				<b-col>
					<b-button class="mt-3"
						style="color:white;background-color:#224B93;padding:1rem;"
						v-b-modal.modal-destination-languages
						@click.prevent="setSourceLanguage()">Choisir cette langue
					</b-button>
				</b-col>
			</b-row>
		</b-modal>
		<b-modal ref="destLangModal"
			hide-footer
			id="modal-destination-languages"
			centered
			title="Dans quelle langue souhaitez-vous sous-titrer les vidéos de votre projet ?"
			size="lg" :style="'color:' + this.primaryColor">
			<b-row>
				<div style="display: flex;">
					<b-col>
						<a href="#" v-for="(destinationLanguage, i) in this.destinationLanguages" :key="i">
							<img class="card-img-top"
								:src="destinationLanguage.img"
								v-bind:class="{ selected: destinationLanguage.isSelected }"
								@click.prevent="getDestinationLanguagesId(i)"> </a>
					</b-col>
				</div>
			</b-row>
			<b-row>
				<b-col v-if="this.noVideoUrlError">
					<p style="color: red;">
						{{ this.noVideoUrlError }}
					</p>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-button class="mt-3"
						style="color:white;background-color:#224B93;padding:1rem;"
						@click.prevent="setDestinationLanguages()">Choisir ces langues
					</b-button>
				</b-col>
			</b-row>
		</b-modal>

		<b-modal ref="langsModal"
			hide-footer
			id="modal-source-languages"
			centered
			title="Génération des sous-titres"
			size="lg"
			:style="'color:' + this.primaryColor">
			<p>Dans quelle langue les personnes interviewées parlent dans ce projet ?</p>
				<div style="display: flex;">

						<a href="#"
							v-for="(sourceLanguage, index) in this.sourceLanguages"
							:key="index"> <img class="card-img-top"
							:src="sourceLanguage.img"
							v-bind:class="{ selected: sourceLanguage.isSelected }"
							@click="getLanguagesId(index)"> </a>

				</div>


					<button class="mt-3"
						style="color:white;background-color:#224B93;padding:1rem;"
						@click="setSourceLanguage()">Choisir cette langue</button>
			<p>Dans quelle langue souhaitez-vous sous-titrer les vidéos de votre projet ?</p>

				<div style="display: flex;">

						<a href="#" v-for="(destinationLanguage, i) in this.destinationLanguages" :key="i">
							<img class="card-img-top"
								:src="destinationLanguage.img"
								v-bind:class="{ selected: destinationLanguage.isSelected }"
								@click.prevent="getDestinationLanguagesId(i)" /> </a>

				</div>

			<b-row>
				<b-col>
					<b-button class="mt-3"
						style="color:white;background-color:#224B93;padding:1rem;"
						@click.prevent="setDestinationLanguages()">Choisir ces langues
					</b-button>
				</b-col>
			</b-row>

			<button @click.prevent="set_langs()">Choisir cette langue</button>

		</b-modal>

		<b-modal size="lg"
			ref="importSubtitleModal"
			title="Sélectionnez le fichier de sous-titres à importer"
			@ok="sendSubtitleFile(importSubtitleLang)">
			<br>
			<p>Votre fichier de sous-titrage doit être de type .srt.</p>
			<p>Afin de garantir la bonne intégration de vos sous-titres, merci de respecter le format de l'exemple téléchargeable
				<a href="#" @click.prevent="getDefaultSubtitle">ici</a> (vous pouvez lire ce fichier avec votre bloc notes)
			</p>
			<b-tabs class="mt-3">
				<b-tab class="subtitle-tab"
					v-for="(language, index) in this.destinationLanguages"
					:key="index"
					:title="language.name">
					<b-form-file accept=".srt"
						:ref="'inputSubtitles' + index" type="file"
						:id="index"
						@change="setSubtitleFileLang(language.lang)"
						v-model="subtitleFile"
						no-drop>
					</b-form-file>
				</b-tab>
			</b-tabs>
		</b-modal>
		<div class="row">
			<div class="col-12 col-lg-7">
				<div class="embed-responsive embed-responsive-16by9">
					<video class="embed-responsive-item"
						:src="video_url"
						controls
						ref="player"></video>
				</div>
				<div class="row">
					<div style="margin-top: 2rem;margin-right: 1rem;">
						<button class="btn btn-success"
							@click.prevent="sendDatas(tmpSubtitleFilename)">{{ $t("Button.validate") }}
						</button>
					</div>
					<div style="margin-top: 2rem;">
						<button v-if="(filesArray.length !== 0)"
							type="submit"
							class="btn btn-preview"
							@click.prevent="generateSubtitles"
							:disabled="!this.hasSubtitles">{{ $t("Button.preview_subtitles") }}
						</button>
					</div>
					<div style="margin-top: 2rem;margin-left:1rem">
						<a href="#"
							@click.prevent="goBack"
							class="btn btn-cancel">{{ $t("Button.cancel_sub") }}</a>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-5">
				<div class="row">
					<button :disabled="(filesArray.length === 0)"
						type="submit"
						class="btn btn-subtitle-import"
						style="margin-right:1rem;"
						@click.prevent="downloadFile($event)">{{ $t("Subtitles.export") }}
					</button>
					<button type="submit"
						@click.prevent="importSubtitles"
						class="btn btn-subtitle-import">{{ $t("Subtitles.import") }}
					</button>
					<button type="submit"
						class="btn mt-2 btn-subtitle-import"
						@click="addSubtitles">{{ $t("Subtitles.generate") }}
					</button>
				</div>
				<div class="row">
					<div id="subtitles_list" v-if="hasSubtitles"
						class="form-group text_area mr-4 mt-4"
						style="overflow-y: auto; height: 350px;">
						<div v-for="(subtitle, d) in this.textSubtitles[this.index]"
							:key="d" class="sub_block">
								<span class="timecodes">
									<label><span>Début : </span><input class="start minutes" type="number" min="0" v-model="subtitle.start_min" @change="trigger_sort">:<input class="start seconds" type="number" min="0" v-model="subtitle.start_sec" max="59.9" step=".1" @change="trigger_sort"></label>
									<label><span>Fin : </span><input class="stop minutes" type="number" min="0" v-model="subtitle.stop_min">:<input class="stop seconds" type="number" min="0" v-model="subtitle.stop_sec" max="59.9" step=".1"></label>
								</span> <span class="controls">
									<button class="play" @click="play_at(subtitle)"><img src="static/images/play.png" alt="Lecture" /></button>
									<button class="delete" @click="delete_line(subtitle)" :disabled="textSubtitles[index].length <= 1"><img src="static/images/delete.png" alt="Supprimer" /></button>
								</span> <input type="text"
							class="form-control no-border sub_text"
							placeholder="..."
							v-model="subtitle.text">
						</div>
						<button id="add_sub_button" class="add_sub" @click="add_sub">Ajouter une ligne</button>
					</div>
					<div class="ml-auto" style="padding-right:30px;">
						<img v-if="(hasSubtitles)"
							v-for="(lang, index) in subtitleFileArray"
							:key="lang.lang"
							:src="destination_subtitles_lang[lang.lang]"
							@click.prevent="setSubtitlesText(index, lang.lang)"
							style="margin-right: 1rem;cursor: pointer;width: 10%;float:right;">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "SubtitlesEdition",
	components: {
		throbber,
		lottie_error,
	},
	data() {
		return {
			origin_text: "",
			target_text: [],
			index: 0,
			video_url: "",
			flagsArray: [],
			subtitlesText: [],
			subtitleFile: null,
			subtitleLang: "",
			hasSubtitles: false,
			canPreview: null,
			tmpSubtitleFilename: null,
			noVideoUrlError: null,
			filesArray: [],
			subtitleFileArray: [],
			oldPath: "",
			importSubtitleLang: "",
			destArray: [],
			sourceArray: [],
			username: sessionStorage.getItem("username"),
			primaryColor: process.env.VUE_APP_PRIMARY_COLOR,
			destinationLanguages: process.env.VUE_APP_DESTINATION_LANGUAGES,
			sourceLanguages: process.env.VUE_APP_ORIGIN_LANGUAGES,
			destination_subtitles_lang: process.env.VUE_APP_FLAGS,
			text_error: "",
			timeout_id: 0,
		};
	},
	beforeRouteEnter(to, from, next) {
		if (to.params.step_type === "App\\StepSpeech") {
			let video_url;
			let video_data;
			axios.get(BASE_URL + "/public/api/stepSpeeches/" + to.params.stepId + "/video_base",
				{headers: {"Authorization": sessionStorage.getItem("auth")}},
			).then(response => {
				video_url = BASE_URL + "/public/storage/videos/generated/" + response.data.url + "#" + new Date().getTime();
				video_data = response.data.data;

				axios.get(BASE_URL + "/public/api/stepSpeeches/" + to.params.stepId,
					{
						headers: {
							"Authorization": sessionStorage.getItem("auth"),
						},
					})
				.then(response => {
					next(vm => {
						let data = response.data.data;
						vm.video_url = video_url;
						let array = [];
						if (data.subtitles !== undefined && data.subtitles.length > 0) {
							vm.tmpSubtitleFilename = data.subtitles[vm.index].name;
							vm.subtitleFileArray = data.subtitles;
							data.subtitles.forEach(function (element) {
								array.push(element.lang);
								vm.subtitleLang = element.lang;
							});
							vm.flagsArray = array;
							vm.canPreview = 0;
							if (vm.$route.query.vurl !== null) {
								vm.fileSubtitlesAbsoluteUrl = video_url;
								if (data.subtitles.length > 0) {
									vm.hasSubtitles = true;
									let subtitle = data.subtitles;
									if (vm.filesArray.length > 0) {
										vm.filesArray = [];
									}
									vm.initSubtitles(to, subtitle, vm);
								}
							}
						}
					});
				})
				.catch(error => {
					this.text_error = this.$root.$t("Errors.message_project") + error;
					this.$refs.modalError.show();
				});

			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});

		}
		else if (to.params.step_type === "App\\StepAmbiance") {
			let video_url;
			let video_data;
			axios.get(BASE_URL + "/public/api/stepAmbiances/" + to.params.stepId + "/video_base",
				{headers: {"Authorization": sessionStorage.getItem("auth")}},
			).then(response => {
				video_url = BASE_URL + "/public/storage/videos/generated/" + response.data.url + "#" + new Date().getTime();
				video_data = response.data.data;
				axios.get(BASE_URL + "/public/api/stepAmbiances/" + to.params.stepId,
					{
						headers: {
							"Authorization": sessionStorage.getItem("auth"),
						},
					})
				.then(response => {
					next(vm => {
						let data = response.data.data;
						vm.video_url = video_url;
						let array = [];
						if (data.subtitles !== undefined && data.subtitles.length > 0) {
							vm.tmpSubtitleFilename = data.subtitles[vm.index].name;
							vm.subtitleFileArray = data.subtitles;
							data.subtitles.forEach(function (element) {
								array.push(element.lang);
								vm.subtitleLang = element.lang;
							});
							vm.flagsArray = array;
							vm.canPreview = 0;
							if (vm.$route.query.vurl !== null) {
								vm.fileSubtitlesAbsoluteUrl = video_url;
								if (data.subtitles.length > 0) {
									vm.hasSubtitles = true;
									let subtitle = data.subtitles;
									if (vm.filesArray.length > 0) {
										vm.filesArray = [];
									}
									vm.initSubtitles(to, subtitle, vm);
								}
							}
						}
					});
				})
				.catch(error => {
					this.text_error = this.$root.$t("Errors.message_project") + error;
					this.$refs.modalError.show();
				});
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		}
	},
	beforeRouteLeave(to, from, next) {
		this.origin_text = "";
		this.target_text = [];
		this.textSubtitles = [];
		this.flagsArray = [];
		this.index = 0;
		this.hasSubtitles = false;
		if (this.filesArray.length > 0) {
			this.filesArray = [];
		}
		this.$destroy();
		next();
	},
	computed: {
		textSubtitles: {
			get() {
				return this.subtitlesText;
			},
			set(v) {
				this.subtitlesText = v;
			},
		},
		fileSubtitlesAbsoluteUrl: {
			get() {
				return this.video_url;
			},
			set(v) {
				this.video_url = v;
			},
		},
		oldSubtitlesPath: {
			get() {
				return this.oldPath;
			},
			set(v) {
				this.oldPath = v;
			},
		},
		sortedFlagsArray: function () {
			let newArray = this.flagsArray;

			function compare(a, b) {
				if (a.name < b.name) {
					return -1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			}

			return newArray.sort(compare);
		},
	},
	methods: {
		trigger_sort() {
			this.subtitlesText[this.index].sort(this.sort_sub);
		},
		sort_sub(a, b) {
			let a1 = (parseFloat(a.start_min) * 60 + parseFloat(a.start_sec));
			let b1 = (parseFloat(b.start_min) * 60 + parseFloat(b.start_sec));

			if (a1 === b1) {
				let a2 = (parseFloat(a.stop_min) * 60 + parseFloat(a.stop_sec));
				let b2 = (parseFloat(b.stop_min) * 60 + parseFloat(b.stop_sec));
				return a2 - b2;
			}

			return a1 - b1;
		},
		async add_sub() {
			let last_index = this.subtitlesText[this.index].length - 1;
			if (last_index > -1) {
				let last = this.subtitlesText[this.index][last_index];
				let start_time = parseInt(last.stop_min) * 60 + parseFloat(last.stop_sec) + 0.1;
				let stop_time = start_time + 1.0;
				this.subtitlesText[this.index].push({
					lang: last.lang,
					start_min: Math.floor(start_time / 60).toString(),
					start_sec: (start_time % 60).toFixed(1),
					stop_min: Math.floor(stop_time / 60).toString(),
					stop_sec: (stop_time % 60).toFixed(1),
					text: "",
				});
			}
			await new Promise(resolve => setTimeout(resolve, 250));
			let list = document.getElementById("subtitles_list");
			list.scrollTo({
				top: list.scrollTopMax,
				behavior: "smooth",
			});
		},
		play_at(sub_block) {
			// let $this = this;
			let start_time = parseInt(sub_block.start_min) * 60 + parseFloat(sub_block.start_sec);
			// let duration = parseInt(sub_block.stop_min) * 60 + parseFloat(sub_block.stop_sec) - start_time;
			this.$refs.player.currentTime = start_time;
			this.$refs.player.play();
			// clearInterval(this.timeout_id);
			// this.timeout_id = setTimeout(function () {
			// 	$this.$refs.player.pause();
			// }, duration * 1000);
		},
		delete_line(line) {
			if (this.subtitlesText[this.index].length > 1) {
				let line_index = this.subtitlesText[this.index].indexOf(line);
				this.subtitlesText[this.index].splice(line_index, 1);
			}
		},
		initSubtitles(route, data, vm) {
			let all_subs = [];

			for (let k = 0; k <= data.length - 1; k++) {
				let lines = null;
				vm.filesArray.push(data[k]);
				let new_subtitles = [];
				if (data[k].text !== null) {
					let string = "";
					lines = data[k].text.split("\n");
					for (let p = 0; p <= lines.length - 1; p++) {
						if (p % 4 === 0) { // Should use first blank line as separator
							if (lines[p] && lines[p + 1] && lines[p + 2]) {
								let t = lines[p + 1].trim().split("-->");
								// let start = parseInt(t[0].trim())
								// let stop = parseInt(t[1].trim())
								let start_parsed = t[0].trim().split(":");
								let start_min = (parseInt(start_parsed[0]) * 60 + parseInt(start_parsed[1])).toString();
								let start_sec = parseFloat(start_parsed[2]).toFixed(1);
								let stop_parsed = t[1].trim().split(":");
								let stop_min = (parseInt(stop_parsed[0]) * 60 + parseInt(stop_parsed[1])).toString();
								let stop_sec = parseFloat(stop_parsed[2]).toFixed(1);

								new_subtitles.push({
									lang: data[k].lang,
									start_min: start_min,
									start_sec: start_sec,
									stop_min: stop_min,
									stop_sec: stop_sec,
									text: lines[p + 2].trim(),
								});
							}
						}
					}
					new_subtitles.sort(vm.sort_sub);
					all_subs.push(new_subtitles);
					for (let j = 0; j <= new_subtitles.length - 1; j++) {
						string += new_subtitles[j] + "\n";
					}
					if (route.params.lang === data[k].lang) {
						vm.origin_text = string;
					}
					else {
						vm.target_text.push(string);
					}
				}
			}

			vm.subtitlesText = all_subs;
		},
		addSubtitles() {
			this.$refs.sourceLangModal.show();
		},
		set_langs() {
			let $this = this;

			for (let i = 0; i <= this.sourceLanguages.length - 1; i++) {
				if (this.sourceLanguages[i].isSelected) {
					sessionStorage.setItem("origin_lang", this.sourceLanguages[i].lang);
				}
			}

			if (this.fileSubtitlesAbsoluteUrl) {
				if (this.destArray.length >= 1) {
					this.destArray.sort(function (a, b) {
						if (a < b) {
							return -1;
						}
						if (a > b) {
							return 1;
						}
						return 0;
					});
					sessionStorage.setItem("dest_lang", JSON.stringify(this.destArray));
					let bodyFormData = new FormData();
					bodyFormData.append("_method", "put");
					bodyFormData.append("sourceLang", sessionStorage.getItem("origin_lang"));
					bodyFormData.append("destinationLang", JSON.parse(sessionStorage.getItem("dest_lang")));
					axios.post(BASE_URL + "/public/api/projects/" + $this.$route.params.id,
						bodyFormData,
						{
							headers: {
								"Content-Type": "multipart/form-data",
								"Authorization": sessionStorage.getItem("auth"),
							},
						},
					).then(function (response) {
						if ($this.$route.params.step_type === "App\\StepSpeech") {
							$this.updateSpeech();
						}
						else {
							$this.updateAmbiance();
						}
					}).catch(error => {
						$this.text_error = this.$root.$t("Errors.message_project") + error;
						$this.$refs.modalError.show();
					});
				}
				else {
					this.text_error = this.$root.$t("Subtitles.error_no_lang");
					this.$refs.modalError.show();
				}
			}
			else {
				this.noVideoUrlError = this.$root.$t("Subtitles.error_no_video");
			}
		},
		setSourceLanguage() {
			if (sessionStorage.getItem("origin_lang")) {
				sessionStorage.removeItem("origin_lang");
			}
			for (let i = 0; i <= this.sourceLanguages.length - 1; i++) {
				if (this.sourceLanguages[i].isSelected) {
					sessionStorage.setItem("origin_lang", this.sourceLanguages[i].lang);
				}
			}
		},
		setDestinationLanguages() {
			let $this = this;
			if (sessionStorage.getItem("dest_lang")) {
				sessionStorage.removeItem("dest_lang");
			}
			if (this.fileSubtitlesAbsoluteUrl) {
				if (this.destArray.length >= 1) {
					this.destArray.sort(function (a, b) {
						if (a < b) {
							return -1;
						}
						if (a > b) {
							return 1;
						}
						return 0;
					});
					sessionStorage.setItem("dest_lang", JSON.stringify(this.destArray));
					let bodyFormData = new FormData();
					bodyFormData.append("_method", "put");
					bodyFormData.append("sourceLang", sessionStorage.getItem("origin_lang"));
					bodyFormData.append("destinationLang", JSON.parse(sessionStorage.getItem("dest_lang")));
					axios.post(BASE_URL + "/public/api/projects/" + $this.$route.params.id,
						bodyFormData,
						{
							headers: {
								"Content-Type": "multipart/form-data",
								"Authorization": sessionStorage.getItem("auth"),
							},
						},
					).then(function (response) {
						if ($this.$route.params.step_type === "App\\StepSpeech") {
							$this.updateSpeech();
						}
						else {
							$this.updateAmbiance();
						}
					}).catch(error => {
						$this.text_error = this.$root.$t("Errors.message_project") + error;
						$this.$refs.modalError.show();
					});
				}
				else {
					this.text_error = this.$root.$t("Subtitles.error_no_lang");
					this.$refs.modalError.show();
				}
			}
			else {
				this.noVideoUrlError = this.$root.$t("Subtitles.error_no_video");
			}
		},
		getLanguagesId(id) { // Needs to be rewritten (radio box would do)
			if (this.sourceLanguages[id].isSelected === false) {
				this.sourceLanguages[id].isSelected = true;
			}
			else {
				this.sourceLanguages[id].isSelected = false;
				if (sessionStorage.getItem("origin_lang")) {
					sessionStorage.removeItem("origin_lang");
				}
			}
			let countArray = 0;
			this.sourceLanguages.forEach(function (a) {
				if (a.isSelected === true) {
					countArray++;
				}
			});
			if (countArray > 1) {
				this.text_error = "Vous ne pouvez pas avoir plus d'une langue source pour un projet.";
				this.$refs.modalError.show();
				this.sourceLanguages.forEach(function (b) {
					b.isSelected = false;
				});
				this.sourceArray.splice(1, 1);
			}
		},
		getDestinationLanguagesId(id) { // Needs to be rewritten (radio box would do)
			if (this.destinationLanguages[id].isSelected === false) {
				this.destinationLanguages[id].isSelected = true;
				this.destArray.push(this.destinationLanguages[id].lang);
			}
			else {
				this.destinationLanguages[id].isSelected = false;
				let index = this.destArray.indexOf(this.destinationLanguages[id].lang);
				if (index > -1) {
					this.destArray.splice(index, 1);
				}
				if (sessionStorage.getItem("destinationLang")) {
					sessionStorage.removeItem("destinationLang");
				}
			}
		},
		sendSubtitleFile(lang) {
			if (this.subtitleFile) {
				let $this = this;
				let bodyFormData = new FormData();
				bodyFormData.append("subtitleFile", $this.subtitleFile);
				bodyFormData.append("stepId", $this.$route.params.stepId);
				bodyFormData.append("stepType", $this.$route.params.step_type);
				bodyFormData.append("tmpSubtitleFilename", $this.tmpSubtitleFilename);
				bodyFormData.append("lang", lang);
				axios.post(BASE_URL + "/public/api/subtitles",
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Authorization": sessionStorage.getItem("auth"),
						},
					},
				).then(function (response) {
					$this.hasSubtitles = true;
					$this.subtitleFileArray = response.data.data;
					$this.tmpSubtitleFilename = response.data.data.name;
					$this.$router.push({name: "ProjectEdition"});
				}).catch(error => {
					$this.text_error = $this.$root.$t("Errors.message_project") + error;
					$this.$refs.modalError.show();
				});
			}
		},
		importSubtitles() {
			this.subtitleFile = null;
			this.$refs.importSubtitleModal.show();
		},
		sendDatas(filename) {
			let path;
			if (this.$route.params.step_type === "App\\StepSpeech") {
				path = BASE_URL + "/public/api/stepSpeeches/updateSubtitles";
			}
			else {
				path = BASE_URL + "/public/api/stepAmbiances/updateSubtitles";
			}
			let $this = this;
			this.$refs.loaderModal.show();
			let string = "";
			let sub_index = 0;
			this.subtitlesText[$this.index].forEach(function (element) {
				sub_index += 1;
				let text = element.text || "...";

				if (element.text !== undefined) {
					string += sub_index + "\n";
					string += $this.format_timecode(element) + "\n";
					string += text + "\n";
					string += "\n";
				}
			});
			axios.post(path, {
				stepId: $this.$route.params.stepId,
				tmpSubtitleFilename: filename,
				text: string,
			}, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			}).then(function (response) {
				let data = response.data;
				$this.$refs.loaderModal.hide();
				$this.filesArray[$this.index].file_relative_url = data.data.relative_url;
				$this.filesArray[$this.index].file_absolute_url = data.data.absolute_url;
				$this.filesArray[$this.index].text = data.data.text;
				$this.canPreview = 1;
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		format_timecode(block) {
			let start_hour = Math.floor(parseInt(block.start_min) / 60);
			let start_min = parseInt(block.start_min) % 60;

			let stop_hour = Math.floor(parseInt(block.stop_min) / 60);
			let stop_min = parseInt(block.stop_min) % 60;

			return String(start_hour).padStart(2, "0") + ":"
				+ String(start_min).padStart(2, "0") + ":"
				+ parseFloat(block.start_sec).toFixed(3).padStart(6, "0")
				+ " --> "
				+ String(stop_hour).padStart(2, "0") + ":"
				+ String(stop_min).padStart(2, "0") + ":"
				+ parseFloat(block.stop_sec).toFixed(3).padStart(6, "0");
		},
		generateSubtitles() {
			let $this = this;
			this.$refs.loaderModal.show();

			let path;
			if (this.$route.params.step_type === "App\\StepSpeech") {
				path = BASE_URL + "/public/api/stepSpeeches/addSubtitles";
			}
			else {
				path = BASE_URL + "/public/api/stepAmbiances/addSubtitles";
			}

			axios.post(path, {
				subtitleLang: $this.subtitleLang,
				stepId: $this.$route.params.stepId,
				file_index: $this.index,
			}, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			}).then(function (response) {
				$this.$refs.player.removeAttribute("poster");
				$this.fileSubtitlesAbsoluteUrl = response.data.data + "#" + new Date().getTime();
				$this.oldSubtitlesPath = response.data.oldName;
				$this.$refs.loaderModal.hide();
			})
			.catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		downloadFile(e) {
			this.filesArray.forEach(function (element) {
				const url = window.URL.createObjectURL(new Blob([element.text], {type: "text/plain"}));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "sous-titre.srt");
				document.body.appendChild(link);
				link.click();
			});
		},
		getDefaultSubtitle() {
			let text = "1\n" +
				"00:00:03.000 --> 00:00:08.200\n" +
				"Bonjour, ici sont les sous-titres affichés sur la durée indiquée au-dessus\n" +
				"\n" +
				"2\n" +
				"00:00:08.200 --> 00:00:15.477\n" +
				"suite du sous-titre sur la durée associée\n" +
				"\n" +
				"3\n" +
				"00:00:15.477 --> 00:00:25.000\n" +
				"ect.... \n";
			const url = window.URL.createObjectURL(new Blob([text], {type: "text/plain"}));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "default-sous-titres.srt");
			document.body.appendChild(link);
			link.click();
		},
		setSubtitlesText(index, lang) {
			this.subtitleLang = lang;
			this.tmpSubtitleFilename = this.subtitleFileArray.filter(sub => sub.lang === lang)[0].name;
			this.index = index;
		},
		next() {
			this.$refs.flickity.next();
		},
		previous() {
			this.$refs.flickity.previous();
		},
		goBack() {
			this.$router.push({name: "ProjectEdition"});
		},
		updateSpeech() {
			let stepId = this.$route.params.stepId;
			let sourceLang = sessionStorage.getItem("origin_lang");
			let destLang = JSON.parse(sessionStorage.getItem("dest_lang"));
			let bodyFormData = new FormData();
			let $this = this;
			if (sourceLang.length > 0 && destLang.length > 0) {
				bodyFormData.append("sourceLang", sourceLang);
				bodyFormData.append("destLang", destLang);
				bodyFormData.append("_method", "PUT");
				axios.post(BASE_URL + "/public/api/stepSpeeches/" + stepId,
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Authorization": sessionStorage.getItem("auth"),
						},
					},
				).then(function (response) {
					$this.recognizeSpeech();
				});
			}
		},
		recognizeAmbiance() {
			let $this = this;
			$this.$refs.loaderModal.show();
			axios.get(BASE_URL + "/public/api/stepAmbiances/" + $this.$route.params.stepId + "/recognize", {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				$this.$refs.loaderModal.hide();
				$this.hasSubtitles = true;
				$this.$router.push({name: "ProjectEdition"});
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
		updateAmbiance() {
			let stepId = this.$route.params.stepId;
			let sourceLang = sessionStorage.getItem("origin_lang");
			let destLang = JSON.parse(sessionStorage.getItem("dest_lang"));
			let bodyFormData = new FormData();
			let $this = this;
			if (sourceLang.length > 0 && destLang.length > 0) {
				bodyFormData.append("sourceLang", sourceLang);
				bodyFormData.append("destLang", destLang);
				bodyFormData.append("_method", "PUT");
				axios.post(BASE_URL + "/public/api/stepAmbiances/" + stepId,
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Authorization": sessionStorage.getItem("auth"),
						},
					},
				).then(function (response) {
					$this.recognizeAmbiance();
				});
			}
		},
		recognizeSpeech() {
			let $this = this;
			$this.$refs.loaderModal.show();

			let path;
			if (this.$route.params.step_type === "App\\StepSpeech") {
				path = BASE_URL + "/public/api/stepSpeeches/" + $this.$route.params.stepId + "/recognize";
			}
			else {
				path = BASE_URL + "/public/api/stepAmbiances/" + $this.$route.params.stepId + "/recognize";
			}

			axios.get(path, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				$this.$refs.loaderModal.hide();
				$this.hasSubtitles = true;
				$this.$router.push({name: "ProjectEdition"});
			})
			.catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		setSubtitleFileLang(lang) {
			this.importSubtitleLang = lang;
		},
	},
};
</script>

<style scoped>
.text_area {
	width: 100%;
	min-width: 50%;
}

.step_div {
	width: 165px;
	height: 190px;
	padding: 2rem 1rem;
	border-top: 8px solid transparent;
}

.step_div:hover {
	border-top: solid #7192CC 8px !important;
}

.active {
	border-top: solid #7192CC 8px !important;
}

a:hover {
	text-decoration: none;
}

.step_text {
	color: #224B93;
	font-size: 14px;
	font-weight: bold;
	margin-top: 3px;
}

.step_in_div {
	border: solid 2px #FF0000;
	height: 100px;
	width: 100px;
}

.slide-fade-enter-active {
	transition: all .5s ease;
}

.slide-fade-leave-active {
	transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
	/* .slide-fade-leave-active below version 2.1.8 */
{
	transform: translateX(-10px);
	opacity: 0;
}

.title_label {
	font-size: 14px;
	color: var(--text-main);
	margin-bottom: 0;
	margin-top: .2rem;
}

.keyText {
	font-size: 12px;
}

.card {
	width: 245px;
	height: 195px;
	border-radius: 10px;
	background-color: #224B93;
	opacity: .5;
	margin-right: 20px;
}

.card-img-top {
	text-align: center;
	height: 100px;
	width: 100px;
	margin: 30px 10px 20px;
	opacity: .5;
}

.selected {
	opacity: 1;
}

.btn-success {
	background: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
}

.btn-cancel {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
}

.btn-info {
	background-color: var(--color-secondary-action);
	border-color: var(--color-secondary-action);
	color: var(--text-secondary-action);
}

.btn-preview {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-secondary-action);
}

.btn-subtitle-import {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
	font-weight: bold;
}

.btn-subtitle-import:hover {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
	font-weight: bold;
}

.sub_block {
	padding: 5px;
	background: #FAFAFA;
	margin-top: 10px;
	display: grid;

	grid-template-areas:
		"timecode controls"
		"text text";
}

.timecodes {
	grid-area: timecode;
}

.controls {
	grid-area: controls;
	place-self: center;
}

.controls button {
	border: none;
	padding: 5px;
	border-radius: 5px;
	margin: 10px;
}

.controls button img {
	display: block;
}

.sub_text {
	grid-area: text;
}

.timecodes label {
	display: block;
}

.timecodes label span {
	display: inline-block;
	width: 70px;
}

.timecodes input {
	width: 60px;
	border: none;
}

.timecodes .minutes {
	text-align: right;
}

.timecodes .seconds {
	text-align: right;
}

.add_sub {
	padding: 10px;
	margin: 10px 20px;
	border-radius: 10px;
	border: none;
	background: var(--color-main-action);
	color: var(--text-main-action);
}
</style>
